import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';

export const LoginHeader: React.FC = () => {
  return (
    <>
      <HStack h='7%' backgroundColor='gray.600'>
        <Box>
          <Text ml='5' fontSize='35px' color='white'>
            運行管理システム
          </Text>
        </Box>
      </HStack>
    </>
  );
};
